import { isBrowser } from "../utils/browser"
import Bugsnag from "@bugsnag/js"
import { Config } from "../utils/config"
import { getLogContext } from "../utils/loggerWrap"

export const logToBugsnag = isBrowser && !!Config.bugSnagClientToken

if (logToBugsnag) {
    Bugsnag.start({
        apiKey: Config.bugSnagClientToken,
        releaseStage: Config.environment,
        enabledReleaseStages: ["production", "development"],
        onError: event => {
            const context = getLogContext()
            event.addMetadata("attributes", { ...context })
        },
    })
}
